<div nz-row class="chart-main-content" [nzGutter]="[16, 16]">
  <!-- Left Panel - Select Query Results -->
  <div nz-col class="left-content" nzSpan="8">
    <nz-card>
      <h3 nz-typography class="nfl-form-label">Select Query Results</h3>
      <div class="query-results-section">
        <!-- Filter and Sort -->
        <nz-space nzDirection="vertical" nzSize="small" class="w100">
          <!-- Filter Row -->
          <div *nzSpaceItem class="filter-row">
            <nz-form-item>
              <nz-form-label nzFor="filter" nzNoColon>Filter</nz-form-label>
              <nz-form-control>
                <nz-select
                  id="filter"
                  nzPlaceHolder="Filter by creators"
                  nzSize="default"
                  nzMode="multiple"
                  nzAllowClear="true"
                  [(ngModel)]="selectedFilters"
                  (ngModelChange)="onFilterChange()"
                >
                  <nz-option *ngFor="let option of filterOptions" [nzLabel]="option.label" [nzValue]="option.value">
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <!-- Sort Row -->
          <div *nzSpaceItem class="sort-row">
            <nz-form-item>
              <nz-form-label nzFor="sort" nzNoColon>Sort by</nz-form-label>
              <nz-form-control>
                <button nz-button nzType="default" nzSize="default" class="sort-button" (click)="toggleSortDirection()">
                  <span>Last Modified</span>
                  <span nz-icon [nzType]="sortDescending ? 'caret-down' : 'caret-up'" nzTheme="outline"> </span>
                </button>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Query Results List -->
          <div *nzSpaceItem class="query-result-list">
            <ng-container *ngIf="!loadingQueries; else loadingQueriesTemplate">
              <div class="query-card-container" *ngIf="queryResults.length > 0; else noQueriesTemplate">
                <nz-card
                  *ngFor="let query of queryResults"
                  nzSize="small"
                  nzHoverable="true"
                  [class.ant-card-selected]="selectedQuery?.executionId === query.executionId"
                  class="query-card-item"
                  (click)="selectQuery(query)"
                >
                  <div nz-row nzAlign="middle" [nzGutter]="8" class="w100">
                    <div nz-col nzFlex="auto">
                      <nz-space nzDirection="vertical" nzSize="small">
                        <span *nzSpaceItem nz-ellipsis nz-typography class="nfl-form-label">{{
                          getQueryDisplayName(query)
                        }}</span>
                        <div *nzSpaceItem>
                          <nz-space nzSize="small">
                            <nz-tag *nzSpaceItem nzColor="green">
                              <span nz-icon nzType="clock-circle" nzTheme="outline"></span>
                              {{ query.lastModifiedAt | dateTime }}
                            </nz-tag>
                          </nz-space>
                        </div>
                      </nz-space>
                    </div>
                  </div>
                </nz-card>
              </div>

              <ng-template #noQueriesTemplate>
                <div class="no-queries-container">
                  <nz-empty nzNotFoundImage="simple" nzNotFoundContent="No data available"></nz-empty>
                </div>
              </ng-template>
            </ng-container>
            <ng-template #loadingQueriesTemplate>
              <div class="query-loader">
                <nz-spin nzSize="large">
                  <div>Loading queries...</div>
                </nz-spin>
              </div>
            </ng-template>
          </div>
          <!-- Pagination -->
          <div *nzSpaceItem class="pagination-container">
            <nz-pagination
              [nzPageIndex]="currentPage"
              [nzTotal]="totalQueries"
              [nzPageSize]="pageSize"
              (nzPageIndexChange)="onPageChange($event)"
              (nzPageSizeChange)="onPageSizeChange($event)"
            ></nz-pagination>
          </div>
        </nz-space>
      </div>
    </nz-card>
  </div>
  <!-- Right Panel - Data Preview -->
  <div nz-col class="right-content" nzSpan="16">
    <nz-card>
      <h3 nz-typography class="nfl-form-label">Data Preview</h3>
      <div class="data-preview-container">
        <ng-container *ngIf="selectedQuery; else noDataSelected">
          <!-- Data Table -->
          <div class="w100">
            <app-workbench-query-result
              [queryRecord]="workbenchSelectedQuery"
              [loadToChartData]="true"
            ></app-workbench-query-result>
          </div>
        </ng-container>

        <ng-template #noDataSelected>
          <nz-empty
            nzNotFoundImage="simple"
            nzNotFoundContent="Please select a query from the left panel to preview data"
          ></nz-empty>
        </ng-template>
      </div>
      <div class="footer-btn">
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          [disabled]="!isQueryValid"
          (click)="onGoToNextStep()"
          nz-tooltip
          [nzTooltipTitle]="nextBtnTooltip"
        >
          <span>Next</span>
          <span nz-icon nzType="arrow-right" nzTheme="outline"></span>
        </button>
      </div>
    </nz-card>
  </div>
</div>
